import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDownsize: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconDownsize"><Path fillRule="evenodd" clipRule="evenodd" d="M10 10H3V8H8V3H10V10Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M21 10H14V3H16V8H21V10Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M14 21V14H21V16H16V21H14Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M8 21V16H3V14H10V21H8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDownsize;
